export const commaNumber = (num = 0) => Number(num).toLocaleString('en-US');

export const formatAmount = (num, space = true) => `₦${space ? ' ' : ''}${commaNumber(num)}`;

export const formatToken = (str) => {
  if (!str) return '';
  str = String(str);
  if (str.indexOf('-') !== -1) return str;
  str = str.toString();
  const totalSplit = Math.floor(str.length / 4);
  let start = 0;
  let end = 4;
  let output = '';
  for (let i = 0; i < totalSplit; i += 1) {
    output += str.slice(start, end);
    output += i === totalSplit - 1 ? '' : '-';
    start += 4;
    end += 4;
  }
  return output;
};

export const formatExcelToDownloadLink = (
  link,
  server = `${process.env.NODE_ENV === 'production'
    ? 'https://files.buypower.ng'
    : 'http://xdev.buypower.ng'}`,
) => {
  const newLink = document.createElement('a');
  newLink.setAttribute('href', `${server}${link}`);
  newLink.setAttribute('download', link);
  document.body.appendChild(newLink);
  // console.log(newLink);
  newLink.click();
  return newLink.remove();
};
